import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../theme/colors";

import {
  FeaturedPostsContainer,
  PostItem,
  PostImageContainer,
  PostImage,
  PostContent,
  PostTitle,
  PostDescription,
  LoadingContainer,
  LoadingSpinner,
  ErrorContainer,
} from "./styledHeader";

const WordPressFeaturedPosts = ({
  baseUrl = "https://www.corporacionbi.com/gt/bancoindustrial",
  postType = "blog-bi",
  postsCount = 3,
}) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const categoryId = 449;

  const fetchFeaturedPosts = async () => {
    try {
      setLoading(true);

      let url = `${baseUrl}/wp-json/wp/v2/${postType}?per_page=${postsCount}&_embed&categories=${categoryId}`;
      console.log("Intentando URL con categoría:", url);

      let response = await fetch(url);

      if (!response.ok && postType !== "posts") {
        console.log("Fallback a posts estándar con categoría");
        url = `${baseUrl}/wp-json/wp/v2/posts?per_page=${postsCount}&_embed&categories=${categoryId}`;
        response = await fetch(url);
      }

      if (!response.ok) {
        throw new Error(
          `Error: ${response.status} - No se pudieron cargar los posts de la categoría`
        );
      }

      const data = await response.json();
      console.log("Posts encontrados con categoría:", data.length);
      setPosts(data);
      setError(null);
    } catch (err) {
      console.error("Error detallado:", err);
      setError(err.message);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeaturedPosts();
  }, [baseUrl, postType, postsCount]);

  const handleRetry = () => {
    setError(null);
    fetchFeaturedPosts();
  };

  const getPostImage = (post) => {
    if (post._embedded && post._embedded["wp:featuredmedia"]) {
      return post._embedded["wp:featuredmedia"][0].source_url;
    }
    return "https://via.placeholder.com/140x140/e2e8f0/64748b?text=Sin+Imagen";
  };

  const stripHtml = (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  };

  const cleanShortcodes = (text) => {
    return text
      .replace(/\[vc_row\]|\[\/vc_row\]/g, "")
      .replace(/\[vc_column.*?\]|\[\/vc_column\]/g, "")
      .replace(/\[vc_column_text.*?\]|\[\/vc_column_text\]/g, "")
      .replace(/\[.*?\]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const truncateText = (text, maxLength = 150) => {
    const cleanedText = cleanShortcodes(text);
    if (cleanedText.length <= maxLength) return cleanedText;
    return cleanedText.slice(0, maxLength) + "...";
  };

  if (loading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <ErrorContainer>
        <div>
          <p>Error al cargar los posts: {error}</p>
          <button
            onClick={handleRetry}
            style={{
              marginTop: "0.5rem",
              padding: "0.5rem 1rem",
              backgroundColor: colors.secondary,
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Reintentar
          </button>
        </div>
      </ErrorContainer>
    );
  }

  return (
    <FeaturedPostsContainer>
      {posts.map((post, index) => (
        <PostItem key={post.id}>
          <PostImageContainer>
            <PostImage
              src={getPostImage(post)}
              alt={stripHtml(post.title.rendered)}
              loading="lazy"
            />
          </PostImageContainer>

          <PostContent>
            <PostTitle
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {stripHtml(post.title.rendered)}
            </PostTitle>

            <PostDescription>
              {truncateText(stripHtml(post.excerpt.rendered))}
            </PostDescription>
          </PostContent>
        </PostItem>
      ))}
    </FeaturedPostsContainer>
  );
};

export default WordPressFeaturedPosts;
